import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "trashClassPlanners",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "trashClassPlanners" */ "./components"),
        import(
          /* webpackChunkName: "trashClassPlanners" */ "./modules/TrashClassPlannersModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "trashClassPlanners",
          reducer,
        });
        return component;
      })
    // .catch(err => {
    //   throw err;
    // })
  ),
});
